var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdicon',{staticClass:"mdi-icon",attrs:{"name":_vm.icon,"size":_vm.component_size}})
}
var staticRenderFns = []

export { render, staticRenderFns }